'use client';

import _objectSpread from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["client", "children", "persistOptions", "onSuccess"];
import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.esm.js';
import * as React from 'react';
import { persistQueryClient } from '@tanstack/query-persist-client-core';
import { QueryClientProvider, IsRestoringProvider } from '@tanstack/react-query';

var PersistQueryClientProvider = function PersistQueryClientProvider(_ref) {
  var client = _ref.client,
      children = _ref.children,
      persistOptions = _ref.persistOptions,
      onSuccess = _ref.onSuccess,
      props = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isRestoring = _React$useState2[0],
      setIsRestoring = _React$useState2[1];

  var refs = React.useRef({
    persistOptions: persistOptions,
    onSuccess: onSuccess
  });
  React.useEffect(function () {
    refs.current = {
      persistOptions: persistOptions,
      onSuccess: onSuccess
    };
  });
  React.useEffect(function () {
    var isStale = false;
    setIsRestoring(true);

    var _persistQueryClient = persistQueryClient(_objectSpread(_objectSpread({}, refs.current.persistOptions), {}, {
      queryClient: client
    })),
        _persistQueryClient2 = _slicedToArray(_persistQueryClient, 2),
        unsubscribe = _persistQueryClient2[0],
        promise = _persistQueryClient2[1];

    promise.then(function () {
      if (!isStale) {
        refs.current.onSuccess == null ? void 0 : refs.current.onSuccess();
        setIsRestoring(false);
      }
    });
    return function () {
      isStale = true;
      unsubscribe();
    };
  }, [client]);
  return /*#__PURE__*/React.createElement(QueryClientProvider, _extends({
    client: client
  }, props), /*#__PURE__*/React.createElement(IsRestoringProvider, {
    value: isRestoring
  }, children));
};

export { PersistQueryClientProvider };